import React, { useEffect, useState, useRef } from "react";
import {
  CalendarOutlined,
  TeamOutlined,
  FolderOpenOutlined,
  BuildOutlined,
  MedicineBoxTwoTone,
  SyncOutlined,
  LogoutOutlined,
} from "@ant-design/icons";
import { Breadcrumb, Layout, Menu, theme, Image } from "antd";
import { confApp } from "../CONF_APP";

const { Content, Footer, Sider } = Layout;

const arrayItems = JSON.parse(sessionStorage.getItem("menu"));


const getIcon = (key) => {
  switch (key) {
    case "1":
      return <FolderOpenOutlined />;
      break;
    case "2":
      return <CalendarOutlined />;
      break;
    case "3":
      return <TeamOutlined />;
      break;
    case "4":
      return <SyncOutlined />;
      break;
    case "5":
      return <MedicineBoxTwoTone />;
      break;
    case "6":
      return <BuildOutlined />;
      break;
    default:
      return <LogoutOutlined />;
      break;
  }
};

// menu.push({ label: "Salir", key: "Salir", icon: getIcon("Salir") });

export const LayoutHome = ({ children, titleItems, selectedKey }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1366); // Initial check
  const [collapsed, setCollapsed] = useState(true);
  const nombreUser = JSON.parse(sessionStorage.getItem("auth")).nombre;
  const [items, setItems] = useState([]);
  const [arrayMenus, setArrayMenus] = useState([]);

  const initialized = useRef(false);

  const deleteCookies = () => {
    document.cookie = `sessionID=;`;
    document.cookie = "expira=;";
  };

  const cerrarSesion = () => {
    sessionStorage.clear();
    deleteCookies();
    const auth = {
      id: 0,
      idUser: "",
      nombre: "",
      sesionIni: undefined,
    };

    sessionStorage.setItem("auth", JSON.stringify(auth));
    window.location = `/#/App`;
  };

  const onClick = (e) => {
    if (e.key === "CerrarSesion") {
      cerrarSesion();
      return;
    }
    window.location = `/#/App/Home/${e.key}`;
  };

  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1366); // Update on resize
    };
    // fetchPaciente();

    window.addEventListener("resize", handleResize);
    // Set up an interval to update the time every second


    let menu = [];
    const esArray = Array.isArray(arrayItems);

    if (!initialized.current) {
      initialized.current = true;
      
      if (esArray) {
        Array.from(arrayItems).forEach((itm) => {
          menu.push({
            label: itm.label,
            key: itm.key,
            icon: getIcon(itm.key),
            children: itm.children,
          });
        });
        setItems(menu);
        setArrayMenus(JSON.parse(sessionStorage.getItem("auth")).permisos);
        console.log(arrayMenus);
      }else{
        window.location.reload();
      }
    }

    return () => {
      window.removeEventListener("resize", handleResize); // Cleanup
    };
  }, []); // Empty dependency array ensures this effect runs only once on mount

  return (
    <Layout
      style={{
        minHeight: isMobile ? "200vh" : "100vh",
        overflowY: "auto",
        overflow: "scroll",
      }}
    >
      <Sider
        collapsible
        collapsed={collapsed}
        onCollapse={(value) => setCollapsed(value)}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Image
            src="/Images/Logo.png"
            width={100}
            style={{ padding: "10px" }}
          />
        </div>
        <div className="demo-logo-vertical" />
        <Menu
          theme="dark"
          selectedKeys={[selectedKey]}
          mode="inline"
          items={items}
          onClick={onClick}
        />
      </Sider>
      <Layout>
        <Content style={{ margin: "0 16px" }}>
          <Breadcrumb style={{ margin: "16px 0" }} items={titleItems} />
          <div
            style={{
              padding: 24,
              minHeight: 360,
              background: colorBgContainer,
              borderRadius: borderRadiusLG,
            }}
          >
            {children}
          </div>
        </Content>
        <Footer style={{ textAlign: "center" }}>
          © Todos los derechos GRUPO RADYXXA México {new Date().getFullYear()} -
          Versión {confApp.VERSION} - Usuario: {nombreUser}
        </Footer>
      </Layout>
    </Layout>
  );
};
